import { atom } from 'jotai';
import {translationType} from "@/lib/definitions/definitions";

export const translationState = atom<translationType>({
    dictionary: {},
    lng: 'en'
});
